import { render, staticRenderFns } from "./PanelText.vue?vue&type=template&id=34917414&scoped=true"
import script from "./PanelText.vue?vue&type=script&lang=js"
export * from "./PanelText.vue?vue&type=script&lang=js"
import style0 from "./PanelText.vue?vue&type=style&index=0&id=34917414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34917414",
  null
  
)

export default component.exports